"use client";

import Link from "next/link";
import { FadeIn, HomeEyebrow, HomeHeading, HomeLead, HomeSection } from "~/components/siteglue/home/section-shell";
import { DirectoryCard } from "~/components/siteglue/directory/directory-card";
import { api } from "~/trpc/react";

export function SiteGlueHomeDirectoryTeaser() {
  const query = api.directory.list.useQuery({ take: 3 });
  const listings = query.data?.listings ?? [];

  return (
    <HomeSection id="directory" tone="white">
      <FadeIn>
        <HomeEyebrow>Directory</HomeEyebrow>
        <HomeHeading className="mt-4 text-4xl font-semibold sm:text-5xl">
          Agents that opted in
        </HomeHeading>
        <HomeLead>
          Public listings require Moonlight Mode. Scores appear only from a ready scan.
        </HomeLead>
      </FadeIn>

      {query.isLoading ? (
        <p className="mt-10 text-sm text-slate-500">Loading listings…</p>
      ) : listings.length === 0 ? (
        <p className="mt-10 rounded-2xl border border-dashed border-slate-300 bg-slate-50 px-6 py-10 text-sm text-slate-600">
          No public Agents are listed yet. Enable Moonlight Mode on Profile to appear here.
        </p>
      ) : (
        <div className="mt-10 grid gap-5 md:grid-cols-3">
          {listings.map((listing) => (
            <DirectoryCard
              key={listing.id}
              listing={{
                ...listing,
                lastVerified: listing.lastVerified ? new Date(listing.lastVerified) : null,
                scores: listing.scores
                  ? {
                      ...listing.scores,
                      lastVerified: listing.scores.lastVerified
                        ? new Date(listing.scores.lastVerified)
                        : null,
                    }
                  : null,
              }}
            />
          ))}
        </div>
      )}

      <p className="mt-8 text-center">
        <Link href="/directory" className="text-sm font-semibold text-[#4f81bd] hover:underline">
          Browse the Directory
        </Link>
      </p>
    </HomeSection>
  );
}
